import { useState, useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import QuoteModal from '@/components/feature/QuoteModal';
import HeroSection from './components/HeroSection';
import CapabilitiesSection from './components/CapabilitiesSection';
import CategoriesSection from './components/CategoriesSection';
import AboutSection from './components/AboutSection';
import ManufacturersSection from './components/ManufacturersSection';
import ContactFooter from './components/ContactFooter';

function useScrollReveal() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    const elements = document.querySelectorAll('.reveal');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
}

function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-6 right-6 z-40 w-11 h-11 flex items-center justify-center bg-primary-500 text-background-950 rounded-full shadow-lg hover:bg-primary-400 transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
      aria-label="Scroll to top"
    >
      <span className="w-5 h-5 flex items-center justify-center">
        <i className="ri-arrow-up-line text-lg"></i>
      </span>
    </button>
  );
}

export default function Home() {
  useScrollReveal();
  const [quoteOpen, setQuoteOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background-950">
      <Navbar onOpenQuote={() => setQuoteOpen(true)} />
      <main>
        <HeroSection onOpenQuote={() => setQuoteOpen(true)} />
        <CapabilitiesSection />
        <CategoriesSection />
        <AboutSection />
        <ManufacturersSection />
      </main>
      <ContactFooter onOpenQuote={() => setQuoteOpen(true)} />
      <ScrollToTop />
      <QuoteModal open={quoteOpen} onClose={() => setQuoteOpen(false)} />
    </div>
  );
}